import apiClient from "../../client/apiClient"

const BASE = "/provisional-grade-scales"

export type ProvisionalBand = {
  minPercentage: number
  maxPercentage: number
  letter: string
  label?: string
  sortOrder?: number
}

export type ProvisionalGradeScale = {
  _id: string
  name: string
  description?: string
  bands: ProvisionalBand[]
  isActive?: boolean
  createdAt?: string
  updatedAt?: string
}

type Payload = {
  name: string
  description?: string
  bands: ProvisionalBand[]
}

export const provisionalGradeScalesApi = {
  list: async (): Promise<{ success: boolean; data: ProvisionalGradeScale[] }> => {
    const res = await apiClient({ method: "GET", url: BASE })
    return res.data
  },
  create: async (data: Payload): Promise<{ success: boolean; data: ProvisionalGradeScale }> => {
    const res = await apiClient({ method: "POST", url: BASE, data })
    return res.data
  },
  update: async (id: string, data: Partial<Payload>): Promise<{ success: boolean; data: ProvisionalGradeScale }> => {
    const res = await apiClient({ method: "PUT", url: `${BASE}/${id}`, data })
    return res.data
  },
  remove: async (id: string): Promise<{ success: boolean; message: string }> => {
    const res = await apiClient({ method: "DELETE", url: `${BASE}/${id}` })
    return res.data
  },
}
